<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="预约状态">
                <a-select v-model="queryParam.rsvStatus" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option :value="config.ReservationStatus.RESERVATED">待审核</a-select-option>
                  <a-select-option :value="config.ReservationStatus.AUDITED">已审核</a-select-option>
                  <a-select-option :value="config.ReservationStatus.COMPLETED">已完成</a-select-option>
                  <a-select-option :value="config.ReservationStatus.REFUSED">已拒绝</a-select-option>

                  <!-- <a-select-option :value="config.ReservationStatus.INVALID">已作废</a-select-option> -->
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="入厂状态">
                <a-select v-model="queryParam.logStatus" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option :value="0">未入厂</a-select-option>
                  <a-select-option :value="1">已入厂</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="业务类型">
                <a-select
                  v-model="queryParam.businessTypeId"
                  :filterOption="filterOption"
                  @change="handleBizChange"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in bizList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="预约单号">
                <a-input v-model.trim="queryParam.reservationNo" placeholder/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="客户/供应商">
                <a-select
                  v-model="queryParam.supplierOrBusId"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in supplierOrBusList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="物料选择">
                <a-select
                  v-model="queryParam.materielId"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in materielList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="司机姓名">
                <a-input v-model.trim="queryParam.driverName" placeholder/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="验证码">
                <a-input v-model.trim="queryParam.verificationCode" placeholder/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item
                label="上门时间"
                :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
                :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }"
              >
                <a-range-picker
                  v-model="queryParam.createTime"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{
                    今天: [moment().startOf('day'), moment().endOf('day')],
                    本月: [moment().startOf('month'), moment().endOf('day')],
                  }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="(!advanced && 8) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!--     <div class="table-operator">
      <a-button style="margin-left: 0px" type="primary" @click="handleExport()">导出</a-button>
    </div>-->
    <div>
      <a-button type="primary" :disabled="!hasSelected" @click="batchApprove" v-if="rolelimit == true">
        批量审核
      </a-button>
      <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `已选中 ${selectedRowKeys.length} 条` }}
        </template>
      </span>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 2150 }"
      :pagination="{
        pageSizeOptions: pageSizeOptionsList,
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
      }"
      class="components-table-demo-nested"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, selectedRows: selectedRows }"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="supplierName" slot-scope="text, record, index">{{
        record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName
      }}</span>
      <!-- <template slot="logoSlot" slot-scope="text, record, index">
        <span><img  v-show="record.qrCodeId !=null && record.qrCodeId != ''" onclick="window.open(this.src)" :src="config.imgApiUrl + record.qrCodeId" width="40" height="15"/> </span>
      </template>-->

      <span slot="verificationCode" slot-scope="text, record, index">
        <a-dropdown>
          <a class="ant-dropdown-link" href="javascript:void(0);">
            {{ text }}
            <a-icon type="down"/>
          </a>
          <span slot="overlay">
            <img
              v-show="record.qrCodeId != null && record.qrCodeId != ''"
              :src="config.imgApiUrl + record.qrCodeId"
              width="200"
              height="200"
            />
          </span>
        </a-dropdown>
      </span>

      <span slot="materielName" slot-scope="text, record, index">
        <a-dropdown>
          <a class="ant-dropdown-link" href="javascript:void(0);">
            {{ text }}
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-for="(item, index) in record.materielList">
              <a-form layout="inline">
                <a-row :gutter="72">
                  <a-col :md="12" :sm="24">
                    <a-form-item label="货物名称：">
                      <span>{{ item.materielName }}</span>
                    </a-form-item>
                  </a-col>

                  <a-col :md="12" :sm="24">
                    <a-form-item label="预约总量：">
                      <span>{{ item.predictQuantity }}</span>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row type="flex" justify="center" v-for="(order, index) in item.orderList">
                  <a-col :md="10" :sm="24">
                    <a-form-item label="订单号：">
                      <span>{{ order.orderNo }}</span>
                    </a-form-item>
                  </a-col>

                  <a-col :md="7" :sm="24">
                    <a-form-item label="剩余量：">
                      <span>{{ order.residueQuantity }}</span>
                    </a-form-item>
                  </a-col>
                  <a-col :md="7" :sm="24">
                    <a-form-item label="预约量：">
                      <span>{{ order.predictQuantity }}</span>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
              <hr/>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>

      <span slot="smsStatus" slot-scope="text, record, index">
        <a v-if="record.sendedStatus == config.SmsSendStatus.send_success" style="color: green">发送成功</a>
        <a v-if="record.sendedStatus == config.SmsSendStatus.send_cacel">发送取消</a>
        <a v-if="record.sendStatus == config.SmsSendStatus.no_send">待发送</a>
        <a v-if="record.sendStatus === config.SmsSendStatus.send_fail" style="color: red">{{ record.failReason }}</a>
      </span>

      <span
        slot="action"
        slot-scope="text, record, index"
        v-if="
          (rolelimit == true && record.logStatus === '010') || (record.logStatus === '010' && record.rsvStatus == '0')
        "
      >

        <a v-if="roleId != config.RoleType.BUSINESS" @click="handleYyedit(record)">修改</a>
        <a-divider type="vertical"/>

        <a @click="handleDel(record)">删除</a>

        <!--   <a-divider  v-if="record.rsvStatus == '0' || record.rsvStatus == '3'"
          type="vertical"
          v-if="
            (record.rsvStatus === config.ReservationStatus.AUDITED ||
              record.status == config.ReservationStatus.REFUSED) &&
            rolelimit == true
          "
        /> -->
        <!--  <a
           @click="handleInvalid(record)"
           v-if="
             (record.rsvStatus === config.ReservationStatus.AUDITED ||
               record.status == config.ReservationStatus.REFUSED) &&
             rolelimit == true
           "
           >作废</a
         >  -->
        <!--  <a-divider
           type="vertical"
           v-if="roleId === config.RoleType.ADMIN && record.sendStatus === config.SmsSendStatus.send_fail"
         />
         <a
           @click="resetErrorCount(record)"
           v-if="roleId === config.RoleType.ADMIN && record.sendStatus === config.SmsSendStatus.send_fail"
           >短信重发</a
         > -->
        <!-- <span v-if="record.rsvStatus === config.ReservationStatus.INVALID">已作废</span> -->
      </span>
    </s-table>

    <a-modal
      title="审核设置"
      style="top: 100px"
      :width="300"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoadings"
    >
      <a-form :form="form">
        <a-radio-group @change="onRadioChange" v-model="value">
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="3">拒绝</a-radio>
        </a-radio-group>
      </a-form>
    </a-modal>

    <a-modal
      title="修改信息"
      style="top: 10px"
      :width="800"
      v-model="yyeditvisible"
      @ok="yyedithandleOk"
      destroyOnClose
      :confirmLoading="false"
    >
      <a-form :form="yyeditform">
        <a-form-item label="物流号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="物流号"
            v-model="mdl.logisticsNo"
            v-decorator="[
              'logisticsNo',
              { initialValue: mdl.logisticsNo, rules: [{ required: true, message: '请输入物流号' }] },
            ]"
            v-bind:disabled="true"
          />
        </a-form-item>
        <a-form-item label="物料" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select
            v-model="mdl.materielId"
            placeholder="请选择"
            v-decorator="[
              'materielId',
              { initialValue: mdl.materielId, rules: [{ required: true, message: '请选择物料' }] },
            ]"
          >
            <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{
              item.name
              }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="车号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-auto-complete
            v-model="mdl.vehicleNo"
            :dataSource="vehicleNoList"
            style="max-width: 400px"
            placeholder=""
            :filterOption="filterOption"
            @change="(value) => changeVehicleNo(value)"
            v-bind:disabled="editlimit"
          />
          <!-- <a-input placeholder="车号" v-model="mdl.vehicleNo"  v-decorator="['vehicleNo', { initialValue: mdl.vehicleNo, rules: [{ required: true, message: '请输入车号'}]}]"/>-->
        </a-form-item>
        <a-form-item label="司机" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            v-bind:disabled="editlimit"
            placeholder="司机"
            v-model="mdl.driverName"
            v-decorator="[
              'driverName',
              { initialValue: mdl.driverName, rules: [{ required: true, message: '请输入司机' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="手机号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            v-bind:disabled="editlimit"
            placeholder="手机号"
            v-model="mdl.phone"
            v-decorator="['phone', { initialValue: mdl.phone, rules: [{ required: true, message: '请输入手机号' }] }]"
          />
        </a-form-item>

        <a-form-item label="预约量" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="预约量"
            v-model="mdl.predictQuantity"
            v-decorator="[
              'predictQuantity',
              { initialValue: mdl.predictQuantity, rules: [{ required: true, message: '请输入预约量' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="上门日期" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-date-picker
            :defaultValue="defaultDate"
            v-model="mdl.appointedDate"
            v-decorator="[
              'appointedDate',
              { initialValue: mdl.appointedDate, rules: [{ required: true, message: '请输入上门日期' }] },
            ]"
            style="max-width: 150px"
            placeholder="请选择日期"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import {
    reservationPage,
    reservationAudit,
    reservationInvalid,
    reservationExport,
    resetErrorCount,
    deleteReservation
  } from '@/api/logistics'
  import {
    getCorpSupplierList,
    corpBusinessList,
    materielList,
    findscanquerybycarno,
    findcarnoinfo,
    findAllByMarkCustomer
  } from '@/api/basic'
  import { yyedit } from '@/api/logistics'

  import { columnsList } from '@/api/sys'
  import { findPrivileBycode } from '@/api/sys'
  import { formatDate } from '../../utils/date.js'
  import { ReservationStatus, SmsSendStatus } from '../../utils/config.js'
  import { getBizTextByValue, getLogStatusTextByValue } from '@/utils/util'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import Bus from '@/layouts/bus'
  import moment from 'moment'

  export default {
    name: 'ReservationList',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList: ['10'],
        description:
          '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        editlimit: false,

        // form: null,
        form: this.$form.createForm(this),
        yyeditform: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        //审核有效记录标记
        approveRemark: true,
        vehicleNoList: [],
        // 查询参数
        queryParam: null,
        rolelimit: false,
        roleId: null,
        bizList: this.$store.getters.bizList,
        bizCodeList: {},
        selectedBizId: null,
        supplierList: [],
        businessList: [],
        materielList: [],
        supplierOrBusList: [],
        supplierOrBusId: null,
        materielSelect: null,
        yyeditvisible: false,
        defaultDate: null,
        confirmLoadings: false,
        // columns: [],

        // 表头
        columns: [
          {
            title: '物流单号',
            dataIndex: 'logisticsNo',
            width: '180px',
            fixed: 'left'
          },
          {
            title: '车号',
            dataIndex: 'vehicleNo',
            width: '130px'
          },
          {
            title: '业务类型',
            dataIndex: 'businessTypeId',
            width: '100px',
            customRender: (text, record) => {
              return getBizTextByValue(this.$store.getters.bizList, record.businessTypeId, text)
            }
          },
          {
            title: '验证码',
            dataIndex: 'verificationCode',
            scopedSlots: { customRender: 'verificationCode' },
            width: '100px'
          },
          {
            title: '客户/供应商',
            dataIndex: 'supplierName',
            width: '290px',
            scopedSlots: { customRender: 'supplierName' }
          },
          {
            title: '货物名称',
            dataIndex: 'materielName',
            width: '180px',
            scopedSlots: { customRender: 'materielName' }
          },

          {
            title: '司机名称',
            dataIndex: 'driverName',
            width: '130px'
          },
          {
            title: '手机号',
            dataIndex: 'phone',
            width: '120px'
          },
          {
            title: '上门日期',
            sorter: true,
            dataIndex: 'appointedDate',
            width: '120px',
            customRender: text => {
              const date = new Date(text)
              return formatDate(date, 'yyyy-MM-dd')
            }
          },
          {
            title: '预约状态',
            dataIndex: 'rsvStatus',
            width: '100px',
            customRender: text => {
              if (text === this.config.ReservationStatus.RESERVATED) {
                return '待审核'
              }
              if (text === this.config.ReservationStatus.AUDITED) {
                return '已审核'
              }
              if (text === this.config.ReservationStatus.COMPLETED) {
                return '已完成'
              }
              if (text === this.config.ReservationStatus.REFUSED) {
                return '已拒绝'
              }
              // if (text === this.config.ReservationStatus.INVALID) {
              //   return '已作废'
              // }
            }
          },
          {
            title: '物流状态',
            dataIndex: 'logStatus',
            width: '150px',
            customRender: (text, record) => {
              return getLogStatusTextByValue(this.bizCodeList, record.businessTypeId, text)
            }
          },
          {
            title: '短信发送状态',
            width: '140px',
            dataIndex: 'smsStatus',
            scopedSlots: { customRender: 'smsStatus' }
          },
          {
            title: '预约单号',
            dataIndex: 'reservationNo',
            width: '180px'
          },
          /*{
            title: '二维码',
            dataIndex: 'qrCodeId',
            width: '100px',
            scopedSlots: { customRender: 'logoSlot' }
          },*/
          {
            title: '预约时间',
            dataIndex: 'createTime',
            width: '200px',
            customRender: text => {
              let date = new Date(text)
              return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            width: '140px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],

        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          if (this.queryParam.supplierOrBusId) {
            if (this.selectedBizId === this.config.BusinessTypeId.purchase) {
              this.queryParam.corpSupplierId = this.queryParam.supplierOrBusId
            }
            if (this.selectedBizId === this.config.BusinessTypeId.sell) {
              this.queryParam.corpBusinessId = this.queryParam.supplierOrBusId
            }
          } else {
            this.queryParam.corpSupplierId = null
            this.queryParam.corpBusinessId = null
          }
          // 查询未出厂(即物流状态为预约)
          /*         if (this.queryParam.rsvStatus === this.config.ReservationStatus.WAIT_IN){
                    this.queryParam.logStatus = '010'
                    this.queryParam.rsvStatus = ''
                  } */
          // 日期处理
          if (this.queryParam.createTime !== undefined && this.queryParam.createTime.length > 1) {
            this.queryParam['startTime'] = formatDate(new Date(this.queryParam.createTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['endTime'] = formatDate(new Date(this.queryParam.createTime[1]), 'yyyy-MM-dd hh:mm:ss')
          } else {
            this.queryParam['startTime'] = null
            this.queryParam['endTime'] = null
          }
          return reservationPage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })
        },

        selectedRowKeys: [],
        selectedRows: [],

        value: 1,
        reservationId: null

        // radioStyle: {
        //   display: 'block',
        //   height: '30px',
        //   lineHeight: '30px',
        // },
      }
    },

    created () {
      this.checkButtonPrivilege()
      this.loadSupplierSelect()
      this.loadBusinessSelect()
      this.loadMaterielSelect()
      // this.loadClomunsList()
      this.roleId = this.$store.getters.roles
      this.bizCodeList = this.$store.getters.bizCodeList
      // 初始化查询条件
      if (!this.queryParam) {
        this.queryParam = { createTime: [moment().startOf('day'), moment().endOf('day')] }
      } else {
        if (this.queryParam.createTime.length > 0) {
          this.queryParam.createTime[0] = moment(this.queryParam.createTime[0])
          this.queryParam.createTime[1] = moment(this.queryParam.createTime[1])
        }
      }
    },
    computed: {
      hasSelected () {
        return this.selectedRowKeys.length > 0
      },
    },
    activated () {
      this.$refs.table.refresh(true)
    },

    methods: {
      batchApprove () {
        // 弹出框显示
        this.visible = true
        console.log('选中的ids:' + this.selectedRowKeys)
        this.batchReservationId = this.selectedRowKeys
      },
      changeVehicleNo (value, isUpperCase) {
        // 限制只能输入7位
        if (value.length > this.config.vehicleNoLength) {
          this.mdl.vehicleNo = value.substring(0, this.config.vehicleNoLength)
        }
        // 转换成大写
        if (isUpperCase === true && value.length >= 7) {
          this.mdl.vehicleNo = value.toUpperCase()
        }
        //查询车子
        if (this.mdl.vehicleNo != '' && this.mdl.vehicleNo.length > 3) {
          new Promise(resolve => {
            const data = findscanquerybycarno({
              vehicleNo: this.mdl.vehicleNo,
              logisticsNo: this.mdl.logisticsNo
            }).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.vehicleNoList = res

          })

          new Promise(resolve => {
            const data = findcarnoinfo({ vehicleNo: this.mdl.vehicleNo }).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.mdl.driverName = res.dname

          })
        }

      },
      handleYyedit (record) {

        new Promise(resolve => {
          const data = findAllByMarkCustomer({ businessId: record.corpBusinessId }).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          console.log(record.vehicleNo)
          this.mdl = Object.assign({}, record)

          //每次打开弹窗之前重置下form表单
          this.yyeditform = this.$form.createForm(this)
          this.mdl.materielId = record.materielList[0].materielId
          this.mdl.predictQuantity = record.materielList[0].predictQuantity
          this.mdl.vehicleNo = record.vehicleNo

          this.mdl.appointedDate = moment(new Date(record.appointedDate), 'YYYY-MM-DD'),
            //   console.log(new Date()+"/"+date);
            this.materielSelect = res
          this.yyeditvisible = true
          //如果物流状态为多少是不允许改车辆
          // if (record.logStatus === '010') {
          //   this.editlimit = true
          // }
        })
      },

      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            // nthis.confirmLoading = true
            return deleteReservation({ no: record.logisticsNo })
              .then(res => {
                if (res.code === '0') {
                  nthis.$refs.table.refresh()
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                //nthis.confirmLoading = false
              })
          },
          onCancel () {
          }
        })
      },

      //分配物流记录按钮权限
      checkButtonPrivilege (record) {

        new Promise(resolve => {
          const data = findPrivileBycode({ code: 'yyjl-handler' }).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {

          if (res == 'yyjl-handler') {
            this.rolelimit = true
          }
        })

      },
      moment,
      disabledDate (current) {
        return current && current > moment().endOf('day')
      },
      loadClomunsList () {
        new Promise(resolve => {
          const data = columnsList({ className: 'com.hst.logistics.vo.ReservationVo' }).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          for (let i = 0; i < res.length; i++) {
            let item = res[i]
            if (item.dataIndex === 'appointedDate') {
              item.customRender = function (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            }
          }
          this.columns = res
        })
      },

      handleBizChange (value) {
        this.selectedBizId = value
        if (value === this.config.BusinessTypeId.purchase) {
          this.supplierOrBusList = this.supplierList
        }
        if (value === this.config.BusinessTypeId.sell) {
          this.supplierOrBusList = this.businessList
        }
      },

      loadSupplierSelect () {
        // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = getCorpSupplierList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.supplierList = res
        })
      },

      loadBusinessSelect () {
        new Promise(resolve => {
          const data = corpBusinessList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessList = res
        })
      },

      loadMaterielSelect () {
        new Promise(resolve => {
          const data = materielList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielList = res
        })
      },

      filterOption (input, option) {
        // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      handleEdit (record) {
        // 弹出框显示
        this.visible = true
        this.reservationId = record.id
      },
      handleOk () {
        const _this = this
        _this.confirmLoadings = true
        reservationAudit(Object.assign({}, { batchReservationId: this.selectedRowKeys, auditStatus: this.value }))
          .then(res => {
            if (res.code === '0') {
              this.selectedRowKeys = [],
                this.selectedRows = [],
                this.$refs.table.refresh()
            }
          })
          .catch(() => {
          })
          .finally(() => {
            _this.confirmLoadings = false
            this.visible = false
          })
      },

      yyedithandleOk () {

        const kthis = this

        console.log(kthis.mdl.materielId + ':' + kthis.mdl.vehicleNo)
        yyedit(Object.assign({}, {
          materialid: kthis.mdl.materielId,
          vehicleno: kthis.mdl.vehicleNo,
          driver: kthis.mdl.driverName,
          tell: kthis.mdl.phone,
          logisticsNo: kthis.mdl.logisticsNo,
          appointedDate: kthis.mdl.appointedDate,
          predictQuantity: kthis.mdl.predictQuantity
        }))
          .then(res => {
            if (res.code === '0') {
              kthis.$refs.table.refresh()
            }
          })
          .catch(() => {
          })
          .finally(() => {
            kthis.yyeditvisible = false
          })
      },
      handleInvalid (record) {
        const that = this
        this.$confirm({
          title: '提示',
          content: '确定要作废吗 ?',
          onOk () {
            reservationInvalid({ reservationId: record.id })
              .then(res => {
                if (res.code === '0') {
                  that.$refs.table.refresh()
                }
              })
              .catch(da => {
                console.log(da)
              })
          },
          onCancel () {
          }
        })
      },

      handleInvalidcheck (record) {
        this.visible = true
        this.reservationId = record.id

      },

      resetErrorCount (record) {
        resetErrorCount({ id: record.smsId })
          .then(res => {
            if (res.code === '0') {
              that.$refs.table.refresh()
            }
          })
          .catch(da => {
            console.log(da)
          })
      },

      onSelectChange (selectedRowKeys, selectedRows) {
        this.approveRemark = true
        console.log('selectedRowKeys changed: ', selectedRows)
        this.selectedRowKeys = selectedRowKeys
        for (var i = 0; i < selectedRows.length; i++) {
          if (selectedRows[i].rsvStatus != 0) {
            this.approveRemark = false
          }
        }
        if (this.approveRemark == false) {
          this.$message.warning('选中的记录包含已审核记录,请重新选择', 3)
          this.selectedRowKeys = []
        }
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      onRadioChange (e) {
        // console.log('radio checked', e.target.value)
      },
      handleExport () {
        Bus.$emit('showSpinning', true, '准备导出...')
        reservationExport(this.queryParam)
          .then(res => {
            if (res.code === '0') {
              const token = Vue.ls.get(ACCESS_TOKEN)
              let fileName = res.data
              let url = this.config.downloadReservationUrl
              url = url + fileName + '&accessToken=' + token
              window.location.href = url
            }
          })
          .catch(da => {
          })
          .finally(res => {
            Bus.$emit('showSpinning', false)
            // this.confirmLoading = false
          })
      }
    },

    watch: {}
  }
</script>
